import { useEffect, useCallback, useState } from 'react';

const isClient = typeof window === 'object';
const isMobile = false;
const visibleMin = isMobile ? 370 : 580;
const scrolledBottomDistance = 2;

const useShowStickyNavigation = (): boolean => {
  const [visible, setVisible] = useState(false);

  const handleScroll = useCallback(() => {
    const isScrolledDown = window.pageYOffset >= visibleMin;
    const isScrolledToBottom =
      document.body.offsetHeight - (window.innerHeight + window.scrollY) <= scrolledBottomDistance;

    setVisible(isScrolledDown && !isScrolledToBottom);
  }, [setVisible]);

  useEffect(() => {
    if (!isClient)
      return () => {
        // noop, placeholder for consistent return
      };

    window.addEventListener('scroll', handleScroll, false);

    return () => {
      window.removeEventListener('scroll', handleScroll, false);
    };
  }, [handleScroll]);

  return visible;
};

export default useShowStickyNavigation;
